import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../../theme';

import {Table, TableHead, TableBody, TableCell, TableRow} from '@material-ui/core';
import {Paper} from '@material-ui/core';
import { formatDateTime } from '../../../../api/date';
import { SortableTable } from '../../../../components/SortableTable';

class ReportConnectDisconnectList_ extends React.Component {

    render(){
        const {t} = this.props

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            }
        };


        let columns = [
            {
                label: t('DateTime'),
                name: 'dt',
                eval: (val)=>{return formatDateTime(val, 'full_date')},
                allowSort: true,
            },
            {
                label: t('User'),
                name: 'userName',
                allowSort: true,
            },
            {
                label: t('Device'),
                name: 'manufacturer',
                eval: (val, row)=>(row.manufacturer + ' ' + row.model),
                allowSort: true,
                sortEval: (val, row)=>(row.manufacturer + ' ' + row.model),
            },
            {
                label: t('Dispatcher'),
                name: 'dispatcher',
                allowSort: true,
            },
            {
                label: t('State'),
                name: 'event',
                eval: (val, row)=>{return row.event===1 ? t('Connected') : t('Disconnected')},
                allowSort: true,
                sortEval: (val, row)=>{return row.event===1 ? t('Connected') : t('Disconnected')},
            },  
        ]

        /**
         * 
         * dispatcher: "x"
​​​
dt: 1713960584747
​​​
event: 1
​​​
manufacturer: "WLLC"
​​​
model: "Application"
​​​
userName: "Administrator"
         * 
         */

        return(
            <Paper style={styles.paper}>


                <SortableTable
                    t={t}
                    rows={this.props.reportData.rows}
                    columns={columns}
                    version={this.props.reportData.version}
                />
{/** 
 * ref={this.tableRef}
 * contextMenu={contextMenu}
 * contextMenuKey="euuid
 * primaryKey="euuid"
 * onMenuClick={this.handleMenuClick.bind(this)}    
 * checkboxSelection
*/}



{/*
                <Table size="small">
                    
                    <TableHead>
                        <TableRow>
                            <TableCell style={styles.head}>{t('DateTime')}</TableCell>
                            <TableCell style={styles.head}>{t('User')}</TableCell>
                            <TableCell style={styles.head}>{t('Device')}</TableCell>
                            <TableCell style={styles.head}>{t('Dispatcher')}</TableCell>
                            <TableCell style={styles.head}>{t('State')}</TableCell>
                        </TableRow>
                    </TableHead>
                    
                    <TableBody>
                        {this.props.reportData.rows && this.props.reportData.rows.map((row,index)=>(
                            <TableRow key={index} >
                                <TableCell>
                                    {formatDateTime(row.dt, 'full_date')}
                                </TableCell>
                                <TableCell>
                                    {row.userName}
                                </TableCell>
                                <TableCell>
                                    {row.manufacturer} {row.model}
                                </TableCell>
                                <TableCell>
                                    {row.dispatcher}
                                </TableCell>
                                <TableCell>
                                    {row.event===1 ? t('Connected') : t('Disconnected') }
                                </TableCell>
                            </TableRow>
                        ))}
                        
                    </TableBody>
                </Table>
                */}
            </Paper>
        );

    }

}

export const ReportConnectDisconnectList = withTranslation()(ReportConnectDisconnectList_);